enum MealEntityType {NORMAL, HEADER, TEXT, PDF};
export {MealEntityType};
